module.exports = __webpack_public_path__ + "img/gsgc2903_1.3eeec821.svg";